<template>
    <div class="localshop-menu">
        <itc-localshop-nav></itc-localshop-nav>
        <div class="main">
            <div class="text-center m-5">
                <h3>¡Bienvenido {{$store.getters.getUserName}}!</h3>
                <hr>
            </div>
            <div class="row m-5">
                <div class="col-6 col-lg-4 my-2">
                    <div class="text-center">
                        <div class="card w-100">
                            <div class="card-body">
                                <h5 class="card-title text-center">Órdenes</h5>
                                <hr>
                                <i class="fas fa-file-invoice fa-10x p-5"></i>
                                <router-link to="/localshop/orders"><button class="btn btn-primary btn-block">Ir</button></router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-6 col-lg-4 my-2">
                    <div class="text-center">
                        <div class="card w-100">
                            <div class="card-body">
                                <h5 class="card-title text-center">Punto de venta</h5>
                                <hr>
                                <i class="fas fa-cash-register fa-10x p-5"></i>
                                <router-link to="/localshop/bill-generator"><button class="btn btn-primary btn-block">Ir</button></router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-6 col-lg-4 my-2">
                    <div class="text-center">
                        <div class="card w-100">
                            <div class="card-body">
                                <h5 class="card-title text-center">Servicio técnico</h5>
                                <hr>
                                <i class="fas fa-tools fa-10x p-5"></i>
                                <router-link to="/localshop/technical-service"><button class="btn btn-primary btn-block">Ir</button></router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LocalShopNav from '@/components/shared/localshop/LocalShopNav'

export default {
    components: {
        'itc-localshop-nav': LocalShopNav
    }
}
</script>

<style lang="scss" scoped>
.main{
    padding-top: 55px;
}
</style>